import AppPaths from "constants/appPaths";
import Connections from "containers/SystemConnections";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";

const SystemConnections = ({ itemAction, itemId, subItem, showSubBreadCrumbNavigationItems, ...props }) => {
    const breadCrumbItems = React.useMemo(
        () => [
            {
                route: AppPaths.TENANT_CONFIGURATION_ITEM.replace(":tenant", props.match.params.tenant).replace(":configurationItem", "systemconnections"),
                text: "System Connections",
            },
        ],
        [props.match.params.tenant],
    );

    const [currentBreadCrumbItems, setCurrentBreadCrumbItems] = useState(breadCrumbItems);

    // TODO: (Andrews) Test this to ensure no infinite loop
    useEffect(() => {
        showSubBreadCrumbNavigationItems(currentBreadCrumbItems);
    }, [currentBreadCrumbItems, showSubBreadCrumbNavigationItems]);

    const addSubBreadCrumbNavigationItems = (items) => {
        setCurrentBreadCrumbItems([...breadCrumbItems, ...items]);
    };

    let action = null;
    let connectionId = null;
    let connectionType = null;
    if (!subItem) {
        action = itemAction;
        connectionType = itemId;
    } else {
        action = itemAction;
        connectionId = itemId;
        connectionType = subItem;
    }

    return (
        <Connections
            key={connectionId || connectionType}
            action={action}
            connectionId={connectionId}
            connectionType={connectionType}
            showSubBreadCrumbNavigationItems={addSubBreadCrumbNavigationItems}
        ></Connections>
    );
};

export default withRouter(SystemConnections);
